import { get, post } from '@/app/core/request';
import { CommonRoutes } from '@/app/api-routes';
import Feedback from '@/types/feedback/Feedback';

class CommonApi {
  async getTranslationMessages(communeId: number | null, locale: string): Promise<any> {
    const id = communeId !== null ? String(communeId) : '0';
    return get<any>(CommonRoutes.translationMessages(id, locale));
  }
  async getWalletTranslationMessages(communeId: number | null, locale: string): Promise<any> {
    const id = communeId !== null ? String(communeId) : '0';
    return get<any>(CommonRoutes.walletTranslationMessages(id, locale));
  }
  async sendUserFeedback(communeId: number, message: any) {
    return post(CommonRoutes.sendFeedback(String(communeId)), message);
  }
  async getApiInfo() {
    return get(CommonRoutes.apiInfo);
  }
}

export default new CommonApi();
